"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBelowTheFoldSelected = exports.FilterSelect = void 0;

var _lodash = require("lodash");

var React = _interopRequireWildcard(require("react"));

var _ShowMore = require("../ShowMore");

var _Flex = require("../Flex");

var _FilterSelectResultItem = require("./Components/FilterSelectResultItem");

var _FilterSelectContext = require("./Components/FilterSelectContext");

var _FilterInput = require("./Components/FilterInput");

var _VisuallyHidden = require("../VisuallyHidden");

var _Text = require("../Text");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var FilterSelect = function FilterSelect(props) {
  return /*#__PURE__*/React.createElement(_FilterSelectContext.FilterSelectContextProvider, props, /*#__PURE__*/React.createElement(_FilterSelect, null));
};

exports.FilterSelect = FilterSelect;
FilterSelect.displayName = "FilterSelect";

var _FilterSelect = function _FilterSelect() {
  var _useFilterSelectConte = (0, _FilterSelectContext.useFilterSelectContext)(),
      filteredItems = _useFilterSelectConte.filteredItems,
      initialItemsToShow = _useFilterSelectConte.initialItemsToShow,
      isFiltered = _useFilterSelectConte.isFiltered,
      items = _useFilterSelectConte.items,
      multiselect = _useFilterSelectConte.multiselect,
      onChange = _useFilterSelectConte.onChange,
      order = _useFilterSelectConte.order,
      query = _useFilterSelectConte.query,
      selectedItems = _useFilterSelectConte.selectedItems; // Dispatch change event


  (0, React.useEffect)(function () {
    if (onChange) {
      onChange({
        items: items,
        filteredItems: filteredItems,
        selectedItems: selectedItems,
        query: query
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [selectedItems]);

  if (items.length === 0) {
    return null;
  }

  var orderItems = function orderItems(items) {
    return (0, _lodash.orderBy)(items, order[0], order[1]);
  };

  var itemsOrdered = orderItems(items);
  var filterdItemsOrdered = orderItems(filteredItems);
  var itemsSorted = multiselect ? // Move selected items to the top
  (0, _lodash.uniqBy)(selectedItems.concat(itemsOrdered), "value") : itemsOrdered;
  var expanded = isBelowTheFoldSelected(selectedItems, itemsSorted);
  var showNoResults = filteredItems.length === 0 && query !== "";
  return /*#__PURE__*/React.createElement(_Flex.Flex, {
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(_FilterInput.FilterInput, {
    mb: 1
  }), query !== "" && /*#__PURE__*/React.createElement(_VisuallyHidden.VisuallyHidden, {
    "aria-live": "polite"
  }, "".concat(filteredItems.length, " result").concat(filteredItems.length === 1 ? "" : "s")), showNoResults && /*#__PURE__*/React.createElement(_Text.Text, {
    variant: "sm"
  }, "No results."), isFiltered ? filterdItemsOrdered.map(function (item) {
    return /*#__PURE__*/React.createElement(_FilterSelectResultItem.FilterSelectResultItem, _extends({
      key: item.value
    }, item));
  }) : /*#__PURE__*/React.createElement(_ShowMore.ShowMore, {
    expanded: expanded,
    initial: initialItemsToShow
  }, itemsSorted.map(function (item) {
    return /*#__PURE__*/React.createElement(_FilterSelectResultItem.FilterSelectResultItem, _extends({
      key: item.value
    }, item));
  })));
};

_FilterSelect.displayName = "_FilterSelect";

var isBelowTheFoldSelected = function isBelowTheFoldSelected(selectedItems, resultsSorted) {
  var selected = selectedItems.map(function (_ref) {
    var value = _ref.value;
    return value;
  });
  var results = resultsSorted.slice(_ShowMore.INITIAL_ITEMS_TO_SHOW).map(function (_ref2) {
    var value = _ref2.value;
    return value;
  });
  var isSelected = (0, _lodash.intersection)(selected, results).length > 0;
  return isSelected;
};

exports.isBelowTheFoldSelected = isBelowTheFoldSelected;